<template>
  <div>
    <ag-grid-vue
      v-if="options.data"
      style="width: 100%; height: 400px"
      class="ag-theme-alpine"
      :options="options"
    ></ag-grid-vue>
  </div>
</template>

<script>
  import { AgChartsVue } from "ag-charts-vue";
  import "ag-grid-community/styles/ag-grid.css";
  import "ag-grid-community/styles/ag-theme-alpine.css";

  export default {
    props: ["dataset"],
    components: {
      AgGridVue: AgChartsVue,
    },
    data() {
      return {
        options: {
          title: {
            text: "",
          },
          data: [],
          series: [
            {
              type: "histogram",
              xKey: "x",
              xName: "X",
            },
          ],
          axes: [
            {
              type: "number",
              position: "bottom",
              title: { text: "" },
              tick: { interval: 2 },
            },
            {
              type: "number",
              position: "left",
              title: { text: "" },
            },
          ],
        },
      };
    },
    watch: {
      dataset: function () {
        this.initialize();
      },
    },
    created() {
      this.initialize();
    },
    methods: {
      initialize() {
        this.dataset.datas.tblData.map((data) => {
          this.options.data.push({ x: +data });
        });
      },
    },
  };
</script>
